module.exports = __webpack_public_path__ + "static/wrow1-8a4dc1a30d88d54a798b904912eab3c1.jpg";